import $ from 'jquery';
import throttle from 'lodash.throttle';
import ReorderElements from './reorder-elements';
import GaTracking from '../../../core/components/ga-tracking';
const CONTAINER_ELEMENT_SELECTOR = '.js__infinite-scroll-container';
const SPINNER_ELEMENT_SELECTOR = '.js__infinite-scroll-spinner';
const ERROR_ELEMENT_SELECTOR = '.js__infinite-scroll-error';
const LOAD_START_SCROLL_OFFSET = 1000;
export default class InfiniteScroll {
    static xhrRequest = null;
    static init($root = $('body'), successCallback) {
        const $container = $root.find(CONTAINER_ELEMENT_SELECTOR);
        if (!$container.length) {
            return;
        }
        $(window).on('scroll', throttle(e => {
            const windowScrollPosition = $(e.currentTarget).scrollTop() || 0;
            this.fetchTemplate(windowScrollPosition, $container, successCallback);
        }, 100));
        const windowScrollPosition = $(window).scrollTop() || 0;
        this.fetchTemplate(windowScrollPosition, $container, successCallback);
    }
    static fetchTemplate(windowScrollPosition, $container, successCallback) {
        const containerOffset = $container.offset() || { top: 0 };
        const containerHeight = $container.outerHeight() || 0;
        const windowHeight = $(window).height() || 0;
        if (windowScrollPosition + windowHeight + LOAD_START_SCROLL_OFFSET > containerOffset.top + containerHeight) {
            this.initDataLoading($container, successCallback);
        }
    }
    static initDataLoading($container, successCallback) {
        const { loadedPage, url, lastPage } = $container.data();
        if (lastPage <= loadedPage || this.xhrRequest) {
            return;
        }
        const $spinner = $container.find(SPINNER_ELEMENT_SELECTOR);
        const $error = $container.find(ERROR_ELEMENT_SELECTOR);
        $spinner.removeClass('d-none');
        $error.addClass('d-none');
        this.xhrRequest = $.ajax({
            type: 'GET',
            url,
            data: { page: loadedPage + 1 },
        })
            .done(data => {
            const $data = $(data);
            $data.insertBefore($spinner);
            $container.data('loaded-page', loadedPage + 1);
            successCallback();
            this.xhrRequest = null;
            ReorderElements.init();
            GaTracking.init($data.first());
        })
            .fail(() => {
            $error.removeClass('d-none');
        })
            .always(() => {
            $spinner.addClass('d-none');
        });
    }
}
